import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const getAllEmployees = async () => {
  try {
    const response = await fetch(`${API}/employees`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

export const updateRole = async (user, id) => {
  console.log('ini data update role', user);
  try {
    const response = await fetch(`${API}/employee/${id}`, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
